<template>
  <div class="app-manager-task-card">
    <template v-if="showWizard">
      <component
        :is="wizard"
        mode="edit"
        :application="selectedApplication"
        :uploader-task-data="uploaderTaskData"
        :disabled="disableWizard"
        :loading="loading"
        @complete="handleWizardComplete"/>
    </template>

    <div v-else class="app-manager-task-card__content">
      <div class="publish-at-block">
        <fg-input
          label="Дата запуска задания"
          class="date-input">
          <el-date-picker
            v-model="model.publish_at"
            disabled
            name="Дата запуска задания"
            type="date"
            format="dd.MM.yyyy"/>
        </fg-input>
      </div>

      <div class="task-time">
        <label>Время на выполнение задания</label>
        <div class="inputs">
          <fg-input
            v-model="hours"
            type="number"
            disabled
            name="Часы"/>
          <div class="text-muted time-separator">
            :
          </div>
          <fg-input
            v-model="minutes"
            type="number"
            class="inputs__minutes"
            disabled
            name="Минуты"/>
        </div>
      </div>

      <div class="task-cost">
        <fg-input
          v-model="model.cost"
          type="number"
          label="Стоимость"
          disabled
          name="Стоимость"/>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex"
import {ElDatePicker} from 'element-plus'
import {getTimeValue} from "@/utils/helpers"
import { defineAsyncComponent } from 'vue'

export default {
  name: "AppManagerTaskCard",
  components: {
    ElDatePicker,
  },
  data() {
    return {
      model: {
        publish_at: '',
        cost: ''
      },
      hours: '01',
      minutes: '00',
      loading: false,
      modelValidations: {}
    }
  },
  computed: {
    ...mapGetters(['selectedTask', 'selectedMainTask', 'selectedApplication']),
    wizard() {
      return {
        update_app_assembly: defineAsyncComponent(() => import('@/components/Pages/Tasks/common/Modals/UpdateTaskWizardVersion')),
        update_assembly_add_purchases: defineAsyncComponent(() => import('@/components/Pages/Tasks/common/Modals/UpdateTaskWizardPurchases')),
        update_app_aso_image: defineAsyncComponent(() => import('@/components/Pages/Tasks/common/Modals/UpdateTaskWizardAso')),
        update_app_aso_image_assembly: defineAsyncComponent(() => import('@/components/Pages/Tasks/common/Modals/UpdateTaskWizard')),
        update_aso_text: defineAsyncComponent(() => import('@/components/Pages/Tasks/common/Modals/UpdateTaskWizardAso')),
        update_aso_image: defineAsyncComponent(() => import('@/components/Pages/Tasks/common/Modals/UpdateTaskWizardAso')),
      }[this.selectedMainTask.type.name]
    },
    showWizard() {
      return [
        'update_aso_text',
        'update_aso_image',
        'update_app_assembly',
        'update_assembly_add_purchases',
        'update_app_aso_image',
        'update_app_aso_image_assembly',
      ].includes(this.selectedMainTask.type.name)
    },
    uploaderTaskData() {
      return this.selectedMainTask.uploader_update || (
        this.selectedMainTask.uploader.type === 'uploader_update' && this.selectedMainTask.uploader
      )
    },
    disableWizard() {
      return this.selectedTask.status.name === 'completed'
    }
  },
  watch: {
    'model.cost': {
      handler(newValue, oldValue) {
        this.model.cost = String(newValue).match(/^0/) ? oldValue : newValue
        this.modelValidations.cost = {
          required: true,
          numeric: true,
          min_value: 1
        }
      }
    }
  },
  methods: {
    ...mapActions({
      updateApplication: 'aso_manager/updateApplication',
    }),
    async handleWizardComplete(model) {
      this.loading = true
      try {
        const result = await this.updateApplication({
          model: {
            application: model,
          }
        })
        this.$emit('close', {reload: result})
      } finally {
        this.loading = false
      }
    }
  },
  beforeMount() {
    if (!this.uploaderTaskData) return
    this.model.cost = this.uploaderTaskData.cost
    this.model.publish_at = this.uploaderTaskData.publish_at
    this.hours = getTimeValue(Math.floor(this.uploaderTaskData.task_time / 3600))
    this.minutes = getTimeValue(Math.floor(this.uploaderTaskData.task_time % 3600 / 60))
  }
}
</script>

<style scoped>

</style>
